import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { SnackBarService } from '../snack-bar.service'

@Component({
  selector: 'app-snack-bar',
  templateUrl: './snack-bar.component.html',
  styleUrls: ['./snack-bar.component.less'],
})
export class SnackBarComponent implements OnInit, OnDestroy {
  show = false
  message: string = '--'
  icon: string = '&#xe914;'
  snackbarSubscription!: Subscription
  constructor(private snackbarService: SnackBarService) {}

  ngOnInit(): void {
    this.snackbarSubscription = this.snackbarService.snackbarState.subscribe((state) => {
      if (state.type) {
        this.icon = state.type
      } else {
        this.icon = '&#xe914;'
      }
      this.message = state.message
      this.show = state.show
      setTimeout(() => {
        this.show = false
      }, 3000)
    })
  }
  close() {
    this.show = false
  }
  ngOnDestroy() {
    this.snackbarSubscription.unsubscribe()
  }
}
